import { PaymentFormFieldType } from '../constants';
/**
 * Returns Label text for payment field
 */
export var getPaymentFieldLabelText = function getPaymentFieldLabelText(key, paymentForm) {
  var _paymentForm$type;
  var type = PaymentFormFieldType.FIELD;
  return (paymentForm === null || paymentForm === void 0 || (_paymentForm$type = paymentForm[type]) === null || _paymentForm$type === void 0 || (_paymentForm$type = _paymentForm$type.find(function (field) {
    return field.uniqueId === key;
  })) === null || _paymentForm$type === void 0 ? void 0 : _paymentForm$type.text) || '';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/getPaymentFieldLabelText.js
// module id = 497
// module chunks = 11